import { render, staticRenderFns } from "./Phases.vue?vue&type=template&id=e5d8dee2&scoped=true"
import script from "./Phases.vue?vue&type=script&lang=js"
export * from "./Phases.vue?vue&type=script&lang=js"
import style0 from "./Phases.vue?vue&type=style&index=0&id=e5d8dee2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5d8dee2",
  null
  
)

export default component.exports